import React from 'react'
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaYoutube, FaTiktok } from 'react-icons/fa'

import env from './../../../../environments/environment'
import { LICENSED_STATES } from './../../../../constants/licensed-states.constants'
import ComplianceDisclaimer from './../../../../components/shared/ComplianceDisclaimer/ComplianceDisclaimer.component'
import './FooterContent.component.scss'

const FOOTER_NAV_ITEMS = [
  { label: 'Home', href: '/' },
  { label: 'Health Insurance', href: '/health-insurance' },
  { label: 'Medicare Insurance', href: '/medicare-insurance' },
  { label: 'Life Insurance', href: '/life-insurance' },
  { label: 'Small Business Insurance', href: '/small-business-insurance' },
  { label: 'Transition Your Agency', href: '/transition-your-agency' },
  { label: 'Find An Agent', href: '/our-licensed-agents' },
]

const SOCIAL_LINKS = [
  {
    Icon: FaFacebookF,
    href: 'https://www.facebook.com/USABenefitsGroup',
    label: 'facebook',
  },
  {
    Icon: FaInstagram,
    href: 'https://www.instagram.com/usabenefitsgroup/?hl=en',
    label: 'instagram',
  },
  {
    Icon: FaLinkedinIn,
    href: 'https://www.linkedin.com/company/usa-benefits-group',
    label: 'linkedin',
  },
  {
    Icon: FaYoutube,
    href: 'https://www.youtube.com/@usabenefitsgroup',
    label: 'youtube',
  },
  {
    Icon: FaTiktok,
    href: 'https://www.tiktok.com/@usabenefitsgroup',
    label: 'tiktok',
  },
]

const FooterContent = () => {
  return (
    <footer className='footer-content'>
      <div className='footer-content__grid'>
        <div className='footer-content__col footer-content__col--left'>
          <h6 className='footer-content__states-heading'>
            <strong>*Richard Banville LLC Licensed States</strong>
          </h6>
          <h6 className='footer-content__states-list'>{LICENSED_STATES.join('\u00A0 ')}</h6>
          <div className='footer-content__copyright'>
            <span>&copy; 2026 </span>
            <p>All Rights Reserved | USA Benefits Group</p>
          </div>
        </div>

        <div className='footer-content__col footer-content__col--center'>
          <a href='/' className='footer-content__logo-link'>
            <img
              src={`https://firebasestorage.googleapis.com/v0/b/${env.integrations.firebase.config.storageBucket}/o/static%2Flogos%2Flogo.usabg-amerilife-plain.md.jpg?alt=media`}
              alt='USA Benefits Group logo with blue, red, and white elements, and text: Health, Life, Senior Insurance.'
              width='1000'
              height='362'
              className='footer-content__logo'
            />
          </a>
          <p className='footer-content__non-govt'>
            A non-government website powered by Richard Banville LLC, a health insurance agency.
          </p>
          <ComplianceDisclaimer variant='long' tone='light' className='footer-content__compliance' />
          <div className='footer-content__contact'>
            <h6>
              <span className='footer-content__contact-label'>Corporate Phone:</span>{' '}
              <a href='tel:18888261966'>1-888-826-1966</a>
            </h6>
            <h6>
              <span className='footer-content__contact-label'>Corporate Email:</span>{' '}
              <a href='mailto:support@usabg.com'>support@usabg.com</a>
            </h6>
            <h6>Corporate Office: 5141 Mariner Blvd, Spring Hill, FL 34609</h6>
          </div>
          <div className='footer-content__social'>
            {SOCIAL_LINKS.map(({ Icon, href, label }) => (
              <a
                key={label}
                href={href}
                target='_blank'
                rel='noopener noreferrer'
                aria-label={label}
                className='footer-content__social-icon'
              >
                <Icon />
              </a>
            ))}
          </div>
        </div>

        <div className='footer-content__col footer-content__col--right'>
          <nav className='footer-content__nav'>
            <ul>
              {FOOTER_NAV_ITEMS.map(({ label, href }) => (
                <li key={label}>
                  <a href={href} className={window.location.pathname === href ? 'active' : ''}>
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export default FooterContent
